import AuthResetPasswordComponent from './AuthResetPasswordComponent';
import {
  ResetPasswordConnectorApollo,
  ValidateResetPasswordTokenConnectorApollo,
} from '@front-activerse/common-components';

const AuthResetPasswordPage = () => {
  return (
    <ResetPasswordConnectorApollo>
      {({ ...resetPassword }) => (
        <ValidateResetPasswordTokenConnectorApollo>
          {({ ...validateToken }) => (
            <AuthResetPasswordComponent
              {...resetPassword}
              {...validateToken}
              loading={resetPassword.loading || validateToken.loading}
            />
          )}
        </ValidateResetPasswordTokenConnectorApollo>
      )}
    </ResetPasswordConnectorApollo>
  );
};

export default AuthResetPasswordPage;
